export const REVENUE_RANGES = [
	{ id: "under-1m", title: "Under $1M" },
	{ id: "1m-10m", title: "$1M-$10M" },
	{ id: "10m-50m", title: "$10M-$50M" },
	{ id: "50m-100m", title: "$50M-$100M" },
	{ id: "100m-200m", title: "$100M-$200M" },
	{ id: "200m-1b", title: "$200M-$1B" },
	{ id: "over-1b", title: "Over $1B" },
];
